import { __assign } from "tslib";
import * as React from 'react';
import Attachment from '../UI/Attachment/Attachment';
import { classes } from './ExpandedAttachments.st.css';
var ExpandedAttachments = function (_a) {
    var isDetailsVisible = _a.isDetailsVisible, attachments = _a.attachments, onAttachmentClick = _a.onAttachmentClick;
    return (React.createElement(React.Fragment, null, isDetailsVisible && attachments.length ? (React.createElement("div", { className: classes.Attachments }, attachments.map(function (attachment) { return (React.createElement(Attachment, __assign({ onAttachmentClick: onAttachmentClick, key: attachment.id, tabIndex: 1 }, attachment))); }))) : null));
};
export default React.memo(ExpandedAttachments);
//# sourceMappingURL=ExpandedAttachments.js.map